class CartRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }
  
    connectedCallback() {
      this.performRecommendations();
      console.log('perform callback');
    }
    
  
    performRecommendations() {

      const recommendations = this.querySelector(
        '[data-recommendations]'
      );

      if (!recommendations) return;

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
            console.log('perform rec text', text);

          const recommendationsHMTL = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]').innerHTML;
          if (!recommendationsHMTL) return;
          this.classList.remove('hidden');
          recommendations.innerHTML = recommendationsHMTL;
          this.initAccordion();
          this.initSlider();
        });
    }
  
    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: '1',
        pagination: {
            el: '.swiper-pagination',
            bulletClass: 'swiper-bullet',
            bulletActiveClass: 'swiper-bullet-active',
            clickable: true,
            renderBullet: function(index, className) {
                return '<span class="' + className + ' swiper-bullet--svg-animation"><svg width="30" height="30" viewBox="0 0 28 28"><circle class="svg__circle" style="animation-duration: ' + this.el.getAttribute('data-duration') + 's" cx="14" cy="14" r="12" fill="none" stroke-width="2"></circle></svg></span>';
            }
        },
        spaceBetween: 8
      });
    }
    initAccordion() {
        $(".reco__accordion-toggle").click(function () {
            if (!$(this).hasClass("active")) {
                $(this).addClass("active");
                $(this)
                    .siblings(".about__accordion-description")
                    .eq($(this).index())
                    .stop()
                    .slideDown(300);
            } else {
                $(this).removeClass("active");
                $(this).siblings(".about__accordion-description").stop().slideUp(300);
            }
        });
    }
  }
  
  customElements.define('cart-recommendations', CartRecommendations);
  